import Alpine from 'alpinejs';

Alpine.data('logoLarge', () => ({
    is_hidden: false,
    is_large: true,
    lastScroll: 0,
    largeThreshold: 400,    // scroll at which logo switches from large → small
    hideAfterLarge: 600,    // scroll after largeThreshold to start hide/show

    init() {
        this.observeHide();
    },

    observeHide() {
      const footer = document.querySelector('footer');

        window.addEventListener('scroll', () => {
            const scroll = window.scrollY;

            if (footer) {
                const rect = footer.getBoundingClientRect();
                this.footerVisible = rect.top < window.innerHeight && rect.bottom > 0;
            }

            // --- LARGE LOGIC ---
            this.is_large = scroll < this.largeThreshold;

            // --- HIDE/SHOW LOGIC ---
            const hideThreshold = this.largeThreshold + this.hideAfterLarge; // 1000px

            if (this.footerVisible) {
                this.is_hidden = true;
            } else if (scroll > hideThreshold) {
                if (scroll > this.lastScroll) {
                    this.is_hidden = true;   // scrolling down → hide
                } else {
                    this.is_hidden = false;  // scrolling up → show
                }
            } else {
                this.is_hidden = false;      // always visible under threshold
            }

            this.lastScroll = scroll;
        });
    }
}));